export const clickEventDatas = {
  // LOGIN
  modal_login: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'find button login',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  button_login: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'do login',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  switch_login_email: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'switch to login with email',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  switch_login_pn: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'switch to login with personal number',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  personal_number: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'Personal Number',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  password: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'Password',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  captcha: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'Captcha',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  login: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'Login',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  login_success: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'Login Success',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  },
  login_error: {
    event: 'default-v1',
    event_action: 'click',
    event_category: 'Login',
    event_label: 'Login Error',
    event_ga: '',
    version: 'v1.1',
    product: 'main',
  }
};
